import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { Link, useParams } from "react-router-dom";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";
import { OrganizationPicker } from "@/zapi-frontend/widgets/Header/ui/_OrganizationPicker";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { NotificationTrigger } from "@/zapi-frontend/features/Notifications";

export function AppHeader() {
  const { id } = useParams();
  const { isLabs } = useMeStore();

  return (
    <div className="w-full h-full flex items-center gap-4">
      <Link
        data-testid="header-logo-link"
        to={getRouteProjects()}
        className="w-10 h-10 inline-flex justify-center items-center [&_svg>path]:hover:fill-innoveraOrange-400 [&_svg>path]:transition-[fill] [&_svg>path]:duration-[3ms]"
      >
        <InnoveraIcon className="w-6 h-6" />
      </Link>

      <div className="w-full h-full flex items-center justify-end">
        <div className="flex items-center gap-2">
          <OrganizationPicker />
          {isLabs && <NotificationTrigger projectId={id ? parseInt(id) : undefined} />}
          <div className="w-[1px] h-3 bg-innoveraZinc-200 ml-2" />
        </div>
      </div>
    </div>
  );
}
